export const ORIGIN = 'ai assistant panel';
export const PANEL_WIDTH = 306;
